module.exports = __webpack_public_path__ + "static/media/cerrar.fa88cc56.svg";